var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",class:[_vm.$style.heading, _vm.$style[_vm.tag], ( _obj = {}, _obj[_vm.$style.margins] = _vm.hasMargins, _obj )]},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }